export const API_KEY = "AIzaSyCs-B-02_d_42ne-sYAlGEFuLqtrb8J5jY";

export default API_KEY;
